/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, {useEffect, useState} from 'react'
import {connect, useDispatch} from 'react-redux'
import {Body2} from '../../../../components'
import dayjs from 'dayjs'
import {Avatar, Button, Divider, Dropdown, Form, Image, Input, Menu, Modal, Popconfirm, Radio, Spin, Upload} from 'antd'
import {dialogCloser, getTaskStatus, kebabMenus, secondaryButton} from '../../../../common/helpers'
import {FileOutlined, LoadingOutlined} from '@ant-design/icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {createTaskAttachment, createTaskComment, deleteTaskAttachment, deleteTaskComment, fetchTaskComments, updateTaskComment, updateTaskStatus} from '../../../../app/Reducers'
import GetCookie from '../../../../hooks/GetCookie'
import KebabMenu from '../../../../components/KebabMenu'
import {apiRequest} from '../../../../app/Apis'
import PdfViewer from '../../../../components/PdfViewer'
import {usePermissionCheck} from '../../../../hooks/usePermissionCheck';
import AuditLogViewer from '../../../../components/AuditLogs/AuditLogViewer';
import {useLocation, useNavigate} from 'react-router-dom';


const priorityColors = {
  low: '#AF78FF',
  normal: '#7785FF',
  high: 'crimson'
}
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


export const ViewTask = ({ task, comments, activeUser }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate();
  const [showAuditDialog, setShowAuditDialog] = useState(false);
  const [actionMenuRecord, setActionMenuRecord] = useState(null);
  const can_add_atachment_to_task = usePermissionCheck('add_atachment_to_task', false, [])
  const can_view_audit_logs = usePermissionCheck('view_audit_logs', false, [])
  const can_update_task = usePermissionCheck('update_task', false, [])
  const can_delete_task = usePermissionCheck('delete_task', false, [])
  console.log({ task })
  // update task status
  const menu = (
    <Menu>
      <Menu.Item key="3" onClick={() => updateTaskStatus_('assigned')}>
        Assigned
      </Menu.Item>
      <Menu.Item key="1" onClick={() => updateTaskStatus_('in_progress')}>
        In Progress
      </Menu.Item>
      <Menu.Item key="4" onClick={() => updateTaskStatus_('in_review')}>
        
        In Review
      </Menu.Item>
      <Menu.Item key="2" onClick={() => updateTaskStatus_('done')}>
        Done
      </Menu.Item>
    
    
    </Menu>
  );
  
  const updateTaskStatus_ = async (status) => {
    console.log('status', status)
    let params = {
      id: task.id,
      payload: {
        status: status
      }
    }
    await dispatch(updateTaskStatus(params))
    
  }
  
  // updating status
  const [updatingStatus, setUpdatingStatus] = useState(false)
  
  // view change
  const [view, setView] = useState('comments')
  const onViewChange = (e) => {
    setView(e.target.value)
  }
  
  useEffect(() => {
    dispatch(fetchTaskComments({ id: task.id }))
    // handleConsultantClick()
    
    return () => {
    
    }
  }, [])
  
  
  const [form] = Form.useForm()
  const [form2] = Form.useForm()
  
  // form on finish
  const onFinish = async (values) => {
    console.log('values', values)
    let commentParams = {
      id: task.id,
      body: values.body
      // mentionable_ids:[]
    }
    
    let attachmentParams = {
      id: task.id,
      attachments: [...fileList.map((file) => file.id), ...task.attachments.map(item => item.id)]
    }
    
    if (fileList.length > 0) {
      await dispatch(createTaskAttachment(attachmentParams))
    }
    if (values.body && values.body.length > 0) {
      await dispatch(createTaskComment(commentParams))
    }
    
    form.resetFields()
    setFileList([])
    
  }
  
  const uploadUrl = process.env.REACT_APP_ENDPOINT + '/files';
  const token = GetCookie('accessToken')
  const [fileList, setFileList] = useState([])
  
  const onFacesheetChange = ({ fileList: newFileList }) => {
    const newFiles = newFileList.map((file) => {
      if (file.response) {
        // Update the file object with the server response URL and ID
        file.url = file.response.url;
        file.id = file.response.data.id;
      }
      return file;
    });
    
    // Update the state with the new file list
    setFileList(newFiles);
    console.log(newFiles)
    // Update the form fields value with the new file IDs
    const attachmentIds = newFiles.map((file) => file.id)
    console.log(attachmentIds)
    form.setFieldsValue({ attachments: [...attachmentIds] });
  };
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  
  const renderDeleteConfirm = (id) => (
    <Popconfirm
      title="Are you sure you want to delete this item?"
      onConfirm={() => handleAttachmentDelete(id)}
      okText="Yes"
      cancelText="No"
    >
      <Button className="mt-2" type="primary" danger>Delete</Button>
    </Popconfirm>
  );
  const handleAttachmentDelete = async (id) => {
    console.log('id', id)
    dispatch(deleteTaskAttachment({ taskId: task.id, id: id }))
  }
  
  const [selected, setSelected] = React.useState(null)
  const actionMenus = kebabMenus(can_update_task, can_view_audit_logs, can_delete_task)
  
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  
  // editing form
  const [editingForm, setEditingForm] = useState(false)
  // selected comment
  const [selectedComment, setSelectedComment] = useState(null)
  // department
  
  const handleOk = async (id) => {
    await dispatch(deleteTaskComment({ taskId: task.id, id }))
    handleCanceldelete()
    
  }
  
  const handleCanceldelete = () => {
    setSelected(null)
  }
  
  async function kebabMenuClick(e, record, actionMenus) {
    console.log(e, record, actionMenus[e.key].title, actionMenus)
    await setSelectedComment(record)
    await setActionMenuRecord(record)
    switch (actionMenus[e.key].title) {
      case 'Edit':
        console.log({ e, record })
        await setEditingForm(true)
        form2.setFieldsValue({ body: record.body })
        break
      case 'Delete':
        setSelected(record.id)
        break
      case 'Audit':
        setShowAuditDialog(true);
        break
      default:
    }
  }
  
  const onFinishEditing = async (values) => {
    console.log('values', values)
    let params = {
      taskId: task.id,
      id: selectedComment.id,
      body: values.body
    }
    await dispatch(updateTaskComment(params))
    form2.resetFields()
    setEditingForm(false)
    
  }
  
  
  // search for consultants by task assignee name and find whixh maches the assignee id then reroute to consultant profile
  const handleConsultantClick = async () => {
    
    
    // use promise to fetch consultants
    let consultants = await new Promise((resolve, reject) => {
      apiRequest.get(`/consultants?name=${task.assignee.name}`).then(res => {
          resolve(res.data.data)
        }
      ).catch(err => reject(err))
      
    })
    
    
    let consultant = consultants.find(item => item.user_id === task.assignee.id)
    if (consultant) {
      setConsultant(consultant)
    }
    console.log('consultant', consultant)
    // navigate(`/consultants/${consultant.id}`)
  }
  // consultant
  const [consultant, setConsultant] = useState(null)
  
  const [pdf, setPdf] = useState(null);
  const [pdfShowing, setPdfShowing] = useState(false);
  const [loading, setLoading] = useState(false);
  return (
    <div className="w-full" style={{ minHeight: '500px' }}>
      {(!!actionMenuRecord && showAuditDialog) && <AuditLogViewer visible={showAuditDialog} onCancel={dialogCloser(setShowAuditDialog)} loading={false}
                                                                  resourceDescription={`${task.assignee.name}'s task`} resourceType={'Patient Task'}
                                                                  defaultValues={{ auditableId: task?.id, auditable: 'task', format: 'json' }}/>}
      <PdfViewer
        pdf={pdf} setLoading={setLoading} loading={loading}
        onCancel={() => setPdfShowing(false)}
        visible={pdfShowing}/>
      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img
          alt="example"
          style={{
            width: '100%'
          }}
          src={previewImage}
        />
      </Modal>
      
      {/* css grid */}
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-7">
          <div className="flex flex-row justify-between items-center w-full">
            <div className="flex flex-row items-center flex-1">
              {/* due date */}
              <p className="mr-4 font-semibold  ">Due: {dayjs(task.due_date).format("DD MMM, YYYY")}</p>
              {/* priority */}
              <div className="p-1 rounded-md text-white px-4 capitalize" style={{ backgroundColor: priorityColors[task.priority] }}>
                {task.priority} Priority
              </div>
            </div>
            <Dropdown dropdownRender={()=>menu} trigger={['click']}>
              {secondaryButton(null, getTaskStatus(task.status), updatingStatus, 'Updating',
                null, null)}
            </Dropdown>
          </div>
          {task.completed_at && <p className="mr-4 my-4 font-semibold text-left  ">Completed: {dayjs(task.completed_at).format("DD MMM, YYYY")}</p>}
          <div className="flex flex-row items-center my-4">
            <div className="rounded-full flex justify-center items-center p-2 bg-gray-200 mr-1">
              <FontAwesomeIcon size="sm" color="grey" icon={['fas', 'lightbulb']}/>
            </div>
            <p className="ml-2 font-semibold capitalize">{task.task_type}</p>
          </div>
          <div className="flex flex-row items-center my-4">
            <div className="rounded-full flex justify-center items-center p-2 bg-gray-200 mr-1">
              <FontAwesomeIcon size="sm" color="grey" icon={['fas', 'list']}/>
            </div>
            <p className="ml-2 font-semibold ">{task.description}</p>
          </div>
          <div className="flex flex-row items-center my-4">
            <div className="rounded-full flex justify-center items-center p-2 bg-gray-200 mr-1">
              {/* <FontAwesomeIcon size='sm' color="grey" icon={['fas', 'clipboard']} /> */}
              <FileOutlined/>
            </div>
            <p className="ml-2 font-normal ">{task.notes}</p>
          </div>
          <div className="flex flex-row items-center my-4">
            <div className="rounded-full flex justify-center items-center p-2 bg-gray-200 mr-1">
              <FontAwesomeIcon size="sm" color="grey" icon={['fas', 'paperclip']}/>
            </div>
            {/* attatchements */}
            
            <div className="flex flex-col">
              {task.attachments.map((attachment, index) => (
                
                <div key={index} className="flex flex-row items-start">
                  
                  {/* <p className='ml-2 font-normal text-blue-400 text-base'  >{attachment.file_name}</p> */}
                  
                  <Body2 onClick={() => window.open(attachment.url, '_blank')} className="text-blue-400 cursor-pointer" style={{ marginLeft: 10 }}>{attachment.file_name}</Body2>
                
                </div>
              ))}
            
            </div>
          </div>
          
          <Form
            name="comment"
            onFinish={onFinish}
            form={form}
          >
            {/* rounded input field with paper plane send  */}
            
            <div className="flex flex-row items-center rounded-md border border-gray-400 p-3 mb-4 flex-1 ">
              
              
              <Form.Item style={{ marginBottom: 0, flex: 1 }} name="body">
                <input type="text" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-slate-300 sm:text-sm sm:leading-6" placeholder="Add comment" />

              </Form.Item>
              
              {/* form submit */}
              <Form.Item style={{ marginBottom: 0 }}>
                <Button type="text" form="comment" key="submit" htmlType="submit" size="middle" b>
                  <FontAwesomeIcon icon={['fas', 'paper-plane']} style={{ color: 'grey' }}/>
                </Button>
              </Form.Item>
            
            
            </div>
            
            {can_add_atachment_to_task && <div className="rounded-md flex justify-center items-center border p-3 m-auto">
              <Form.Item
                style={{ width: '100%', marginBottom: 0 }}
                name="attachments"
                rules={[{ required: false, message: 'Missing Document' }]}
              
              >
                <Upload accept="image/*,.pdf"
                        action={uploadUrl}
                        headers={{ 'Authorization': `Bearer ${token}` }}
                        fileList={[...fileList]}
                        listType="picture-card"
                        onChange={onFacesheetChange}
                        onPreview={handlePreview}
                  
                  // max file size
                
                
                >
                  <div>
                    <p className="mr-2">Attachment</p>
                    <FontAwesomeIcon size="md" color="grey" icon={['fas', 'paperclip']}/>
                  </div>
                
                
                </Upload>
                <Input autoComplete={'off'} style={{ width: '100%', display: 'none' }}/>
              </Form.Item>
              {fileList.length ? <Button type="primary" form="comment" key="submit" htmlType="submit" size="middle">
                
                Save attachments <FontAwesomeIcon icon={['fas', 'paper-plane']} style={{ color: 'white', marginLeft: '10px' }}/>
              </Button> : null}
            </div>}
          </Form>
          
          <Radio.Group className="mr-4 my-4" onChange={onViewChange} defaultValue="comments"
                       buttonStyle="solid">
            {/* <Radio.Button value="all"> All </Radio.Button> */}
            <Radio.Button value="comments">Comments</Radio.Button>
            <Radio.Button value="kanban">attachments</Radio.Button>
          
          </Radio.Group>
          
          
          {/* comments */}
          {view === "comments" ? <div className="flex flex-col">
              {comments?.map((comment, index) => (
                <div className="flex flex-col">
                  <div className="flex flex-row items-center">
                    <Avatar size={30} src={comment.created_by?.profile_image_url} alt={"WP"}>{comment.created_by?.name?.charAt(0)}</Avatar>
                    
                    <p className="font-semibold  mx-1 mb-0">{comment.created_by?.name}</p>
                    
                    <p className="font-normal text-base mb-0">added</p>
                    <div className="rounded bg-gray-200 p-1 mx-2">
                      <p className="font-semibold text-md mb-0">Comment</p>
                    
                    </div>
                    <p className="font-normal text-md flex-1 mb-0"> {dayjs(comment.created_at).format("MMM DD, YYYY, HH:MM A")}</p>
                    
                    {/* kebab menu */}
                    
                    <KebabMenu
                      menus={kebabMenus(comment.created_by.id === activeUser.id, true, comment.created_by.id === activeUser.id)}
                               recordItem={comment}
                      handleMenuClick={(e) => kebabMenuClick(e, comment, kebabMenus(comment.created_by.id === activeUser.id, true, comment.created_by.id === activeUser.id))}

                      resource={'comment'} handleOk={() => handleOk(comment.id)} handleCancel={handleCanceldelete} confirmLoading={confirmLoading}
                               showConfirmDialog={selected === comment.id}/>
                  </div>
                  <div className="rounded-md bg-gray-100 p-2 m-4">
                    <p className="font-normal mb-0">{comment.body}</p>
                  </div>
                  {editingForm && selectedComment.id === comment.id ?
                    (<Form
                      name="comment_edit"
                      onFinish={onFinishEditing}
                      form={form2}
                      initialValues={{ ...selectedComment }}
                    >
                      
                      
                      {/* rounded input field with paper plane send  */}
                      
                      <div className="flex flex-row items-center rounded-md border border-gray-400 p-3 mb-4 flex-1 ">
                        
                        
                        <Form.Item style={{ marginBottom: 0, flex: 1 }} name="body">
                          <input type="text" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-slate-300 sm:text-sm sm:leading-6" placeholder="Add comment" />

                        </Form.Item>
                        
                        {/* form submit */}
                        <Form.Item style={{ marginBottom: 0 }}>
                          <Button type="text" form="comment_edit" key="submit" htmlType="submit" size="middle" b>
                            <FontAwesomeIcon icon={['fas', 'paper-plane']} style={{ color: 'grey' }}/>
                          </Button>
                        </Form.Item>
                      
                      
                      </div>
                    
                    
                    </Form>) : null
                  }
                </div>
              
              
              ))}
            
            
            </div> :
            
            
            <div className="flex flex-row flex-wrap">
              {task.attachments.map((item, index) => (
                <div className="p-2 w-fit h-fit flex flex-col itemms-center ">
                  
                  {item && (!item.file_name.includes('pdf')) ?
                    <Image width={150} height={150} src={item.url} alt={item.file_name}
                           fallback="data:image/png;base64,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"
                    /> :
                    <img style={{ width: "100px", cursor: 'pointer' }}
                         aria-disabled={loading}
                         onClick={() => {
                           setPdf(item.url)
                           setLoading(true)
                           setPdfShowing(true);
                         }} src={require('../../../../assets/doc.png')} alt="doc"/>
                  }
                  
                  
                  <a href={item.url} download={item.file_name}>
                    {item.file_name}
                  </a>
                  {renderDeleteConfirm(item.id)}
                </div>
              
              ))}
            </div>
          }
        
        
        </div>
        <div className="col-span-5">
          <p className="font-semibold text-gray-400 mb-4">Department</p>
          <div className="flex flex-row items-center mb-4">
            <div className="rounded-full flex justify-center items-center p-2 bg-gray-200 mr-1">
              <FontAwesomeIcon size="sm" color="grey" icon={['fas', 'user-friends']}/>
            </div>
            <p className="ml-2 font-semibold ">{task.department?.name}</p>
          </div>
          <p className="font-semibold text-gray-400 mb-4">Assignee</p>
          <div className="flex justify-between items-center my-2">
            {/* avatar */}
            <div className="flex flex-row items-center">
              <Avatar size={30} src={task.assignee?.url} alt={task.assignee?.name}>
                {task.assignee?.name?.charAt(0).toUpperCase()}
              </Avatar>
              <p className="font-semibold  ml-2">{task.assignee?.name}</p>
            </div>
            {/* {consultant && <Body2 onClick={() => navigate(`/consultants/${consultant.id}`)}>View Profile</Body2>} */}
          </div>
          <Divider/>
          <p className="font-semibold text-gray-400 mb-4">Patient</p>
          <div className="flex flex-row items-start justify-between">
            
            <div className="flex flex-row items-start">
              <div className="rounded-full flex justify-center items-center p-2 bg-gray-200 mr-1">
                <FontAwesomeIcon size="sm" color="grey" icon={['fas', 'user-injured']}/>
              </div>
              
              
              <div className="flex flex-col ml-2">
                <div className="flex flex-row items-center">
                  <p className="font-semibold ">
                    {task.patient?.name}
                  </p>
                  <p className="text-gray-500 font-medium">
                    {/* patient age using day js diff */}
                    ({task.patient?.age}, y.o)
                  </p>
                </div>
                <p className="my-1">
                  {task.patient?.address_1}
                </p>
                <p className="text-blue-400 my-1">
                  {task.patient?.phone_no}
                </p>
                <p className="text-blue-400 my-1">
                  {task.patient?.email}
                </p>
              </div>
            </div>
            
            <Body2 onClick={() => navigate(`/patients/${task.patient.id}`)}>view patient</Body2>
          </div>
          <Divider/>
          <div className="flex flex-col justify-end">
            {/* <p className="text-gray-500 font-medium text-right">
                              Created by {task.creator?.name} on {dayjs(task.created_at).format("MM/DD/YYYY")}

                            </p> */}
            <p className="text-gray-500 font-medium text-right mb-4">
              Reporter {task.reporter.name}
            
            </p>
            <p className="text-gray-500 font-medium text-right">
              Last updated on {dayjs(task.updated_at).format("MM/DD/YYYY")}
            </p>
          
          
          </div>
        </div>
      
      
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  
  task: state.tasks.selectedTask,
  comments: state.tasks.comments,
 activeUser: state.auth.activeUser,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ViewTask)   